module.exports = __webpack_public_path__ + "static/media/coin-black.71f26921.svg";